module.exports = __webpack_public_path__ + "img/logo.3a22b4fb.png";